export const MAPBOX_CONFIG = {
  INITIAL_VIEW_STATE: {
    latitude: 59.275263,
    longitude: 15.213411,
    zoom: 5,
  },
  MIN_ZOOM: 5,
  ACCESS_TOKEN: process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN || '',
  POINT_MIN_ZOOM: 5,
  CLUSTER_MAX_ZOOM: 4,
  CLUSTER_RADIUS: 50,
  DEFAULT_ZOOM_DURATION: 1500,
  CLUSTER_ZOOM_DURATION: 500,
  // Performance optimizations
  PERFORMANCE_SETTINGS: {
    // Reduce tile quality for faster loading
    maxTileCacheSize: 50, // Default is 500
    // Disable expensive features
    renderWorldCopies: false,
    // Optimize rendering
    optimizeForTerrain: false,
    // Reduce precision for better performance
    maxPitch: 0, // Disable 3D tilt
    // Faster transitions
    fadeDuration: 0, // Disable fade animations
  },
};
